import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { Helmet } from 'react-helmet-async';
import { AboutHeader } from '@/components/about/AboutHeader';
import { AboutFooter } from '@/components/about/AboutFooter';
import { useAuth } from '@/hooks/useAuth';

const NotFound: React.FC = () => {
  const { user } = useAuth();

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | Metefy</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to Metefy's homepage." />
        <meta property="og:title" content="404 - Page Not Found | Metefy" />
        <meta property="og:description" content="The page you're looking for doesn't exist. Return to Metefy's homepage." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.metefy.com/404" />
        <meta property="og:image" content="https://www.metefy.com/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="404 - Page Not Found | Metefy" />
        <meta name="twitter:description" content="The page you're looking for doesn't exist. Return to Metefy's homepage." />
        <meta name="twitter:image" content="https://www.metefy.com/og-image.png" />
        <link rel="canonical" href="https://www.metefy.com/404" />
      </Helmet>

      <div className="flex flex-col min-h-screen bg-[#FAFAFA]">
        <AboutHeader user={user} />
        
        <main className="flex-1 flex items-center justify-center py-16 px-4">
          <div className="max-w-md w-full text-center">
            <div className="mb-8">
              <img 
                src="/assets/404.svg" 
                alt="404 Illustration" 
                className="w-64 h-64 mx-auto"
              />
            </div>
            
            <h1 className="text-4xl font-bold text-[#4B0055] mb-4">
              Page Not Found
            </h1>
            
            <p className="text-[#333333] mb-8">
              The page you're looking for doesn't exist or has been moved. 
              Let's get you back on track.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/">
                <Button 
                  className="w-full sm:w-auto bg-gradient-to-br from-[#FAFAFA] to-[#E8F5FF] text-black border-2 border-[#00AEEF] shadow-xl font-semibold"
                >
                  Return Home
                </Button>
              </Link>
              
              <Link to="/blog">
                <Button 
                  variant="outline"
                  className="w-full sm:w-auto border-2 border-[#FFB3C1] text-black hover:bg-[#FFB3C1]/10"
                >
                  Read Our Blog
                </Button>
              </Link>
            </div>
          </div>
        </main>

        <AboutFooter />
      </div>
    </>
  );
};

export default NotFound; 